<template>

  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = !showSearchBar"
                  />
                </b-input-group-append>
              </b-input-group>

              <b-dropdown
                id="dropdown-form-active-entitlement"
                ref="filter_dropdown_all_entitlement"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <entitlement-dropdown-filters
                  :status-filter.sync="statusFilter"
                  :type-filter.sync="typeFilter"
                  :paid-entitlement-filter.sync="paidEntitlementFilter"
                  :scheme-filter.sync="schemeFilter"
                  :start-date.sync="startDateFilter"
                  :scheme-options="schemeOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="startDateFilter || statusFilter.length || typeFilter.length || paidEntitlementFilter.length || schemeFilter.length">
          <hr class="dividerHR filter-divider">
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-if="startDateFilter"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="startDateFilter = ''"
                  >
                    {{ startDateFilter }}
                  </b-form-tag>
                </li>
                <li
                  v-for="statusVal in statusFilter"
                  :key="statusVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromStatusFilter(statusVal)"
                  >
                    <span class="text-capitalize">{{ statusVal.replace("-", " ") }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="statusVal in typeFilter"
                  :key="statusVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromTypeFilter(statusVal)"
                  >
                    <span class="text-capitalize">{{ statusVal.replace("-", " ") }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="statusVal in paidEntitlementFilter"
                  :key="statusVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromPaidEntitlementFilter(statusVal)"
                  >
                    <span class="text-capitalize">{{ statusVal.replace("-", " ") }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="statusVal in schemeFilter"
                  :key="statusVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromSchemeFilter(statusVal)"
                  >
                    <span class="text-capitalize">{{ resolveSchemeName(statusVal) }}</span>
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refUsedEntitlementsTable"
        class="position-relative event_list min-height-300"
        :items="fetchEntitlements"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Role -->
        <template #cell(stringID)="data">
          <div class="text-nowrap">
            <b-button
              v-if="canViewThisAction('show', 'Entitlement')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'customers-entitlements-show', params: { id: data.item._id } }"
            >
              {{ data.item.stringID }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button"
            >
              {{ data.item.stringID }}
            </b-button>
          </div>
        </template>

        <template #cell(name)="data">
          {{ data.item.name }}
          <feather-icon
            v-if="data.item.schemeItemID"
            v-b-modal.terms-condition-modal
            icon="InfoIcon"
            size="16"
            class="ml-25 mt-25 text-muted cursor-pointer"
            @click="openTermsModal(data.item)"
          />
        </template>

        <template #cell(fileID)="data">
          <div class="text-nowrap">
            <b-button
              v-if="canViewThisAction('show', 'File')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'customers-files-show', params: { id: data.item.fileID.fileID } }"
            >
              {{ data.item.fileID.fileNo }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="text-bold align-middle detail-view-id not-button"
            >
              {{ data.item.fileID.fileNo }}
            </b-button>
          </div>
        </template>

        <template #cell(schemeID)="data">
          <div class="text-nowrap">
            <b-button
              v-if="canViewThisAction('show', 'EntitlementScheme')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'products-schemes-show', params: { id: data.item.schemeID._id } }"
            >
              {{ data.item.schemeID.stringID }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="text-bold align-middle detail-view-id not-button"
            >
              {{ data.item.schemeID.stringID }}
            </b-button>
            <p>{{ data.item.schemeID.name }}</p>
          </div>
        </template>

        <template #cell(validUntil)="data">
          <div
            v-if="data.item.lifeTime"
            class="text-nowrap"
          >
            <span class="">Life Time</span>
          </div>
          <div
            v-else-if="data.item.validUntil"
            class="text-nowrap"
          >
            <span class="">{{ dateFormat(data.item.validUntil) }}</span>
          </div>
          <div v-else>
            -
          </div>
        </template>

        <template #cell(createdAt)="data">
          <div class="text-nowrap">
            <span>{{ data.item.createdBy.name }}</span>
            <br>
            <span class="">{{ dateFormatWithTime(data.item.createdAt) }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            :variant="`light-${resolveEntitlementStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
          <small
            v-if="data.item.statusType"
            class="text-muted d-block"
          >
            <template v-if="data.item.statusType === 'service_request' && data.item.statusReferenceID">
              <div class="d-flex">
                <span class="mr-25">via</span>
                <b-button
                  v-if="canViewThisAction('show', 'ServiceRequest')"
                  :to="{ name: 'operation-service-requests-show', params: { id: data.item.statusReferenceID } }"
                  class="font-weight-bold p-0"
                  variant="link"
                >
                  {{ data.item.statusReference }}
                </b-button>
                <span v-else>
                  {{ data.item.statusReference }}
                </span>
              </div>
            </template>

            <template v-else>
              {{ resolveStatusTypeLabel(data.item.statusType, data.item.statusReference) }}
            </template>
          </small>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('show', 'Entitlement')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="canViewThisAction('undo-redemption', 'Entitlement') && data.item.status == 'redeemed'"
              @click="undoRedemption(data.item)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Undo Redemption</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canViewThisAction('send-email', 'Entitlement')"
              @click="sendEmail(data.item)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Re-send Email</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canViewThisAction('update', 'Entitlement')"
              id="toggle-btn"
              v-b-modal.modal-update-remarks-all-entitlement
              @click="setEntitlementRemarks(data.item)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit Internal Remarks</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
    </b-card>

    <div
      v-if="totalEntitlements > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalEntitlements"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>

    <b-modal
      id="modal-update-validuntil-all-entitlement"
      ref="update-status-modal"
      modal-class="status-update-modal"
      cancel-variant="flat-primary"
      ok-variant="success"
      ok-title="Save Changes"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Edit Validity"
      @ok="submitForm"
    >
      <b-form @submit.prevent="submitForm">
        <validation-observer
          ref="entitlementValidUntilEditForm"
        >
          <!-- <b-form-group
            label="Valid Until*"
            label-for="h-entitlement-validUntil"
          >
            <validation-provider
              #default="{ errors }"
              name="Valid Until"
              vid="validUntil"
              rules="required"
            >
              <b-input-group>
                <flat-pickr
                  id="h-validUntil"
                  v-model="validUntil"
                  class="form-control flat-pickr-group"
                  placeholder="Valid Until"
                  :config="flatPickrConfig"
                  @input="validUntilValidation == true ? validUntilValidation = false : null"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="CalendarIcon"
                    class="cursor-pointer"
                    data-toggle
                    size="18"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
              <small
                v-if="validUntilValidation"
                class="text-danger"
              >
                {{ validUntilError }}
              </small>
            </validation-provider>
          </b-form-group> -->
          <b-form-group class="regular-label">
            <div>
              <div
                class="d-flex"
                style="gap: 10px;"
              >
                <div style="width: 50%;">
                  <!-- Validity Year -->
                  <validation-provider
                    #default="{ errors }"
                    name="Validity Year"
                    vid="validityYear"
                  >
                    <v-select
                      id="h-scheme-validityYear"
                      v-model="validityYear"
                      label="title"
                      :options="validityYears"
                      :reduce="title => title.code"
                      :clearable="false"
                      :disabled="lifeTime"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
                <div style="width: 50%;">
                  <!-- Validity Type -->
                  <validation-provider
                    #default="{ errors }"
                    name="Validity Type"
                    vid="validityType"
                  >
                    <v-select
                      id="h-scheme-validityType"
                      v-model="validityType"
                      label="title"
                      :options="validityTypes"
                      :reduce="title => title.code"
                      :clearable="false"
                      :disabled="lifeTime"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div
              class="flex-grow-1 d-flex justify-content-start"
              style="padding-top:8px;"
            >
              <!-- ✅ New Checkbox -->
              <b-form-checkbox
                v-model="lifeTime"
                class="mt-0"
                style="white-space: nowrap;"
              >
                Lifetime
              </b-form-checkbox>
            </div>
            <small class="text-muted-999">
              From date of issuance, as assigned when this entitlement is issued to a customer. Customer will have this period of time to redeem/consume this entitlement.
            </small>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
    <b-modal
      id="modal-update-remarks-all-entitlement"
      ref="update-remarks-modal"
      modal-class="status-update-modal"
      cancel-variant="flat-primary"
      ok-variant="success"
      ok-title="Save Changes"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Edit Internal Remarks"
      @ok="submitRemarksForm"
    >
      <b-form @submit.prevent="submitRemarksForm">
        <validation-observer
          ref="entitlementRemarksEditForm"
        >
          <b-form-group
            label-for="h-entitlement-status"
          >
            <validation-provider
              #default="{ errors }"
              name="Status"
              vid="status"
              rules="required"
            >
              <b-form-textarea
                id="h-remarks"
                v-model="internalRemarks"
                placeholder="Internal Remarks"
                :state="(errors.length > 0 || remarksValidation) ? false : null"
                name="remarks"
                rows="3"
              />
              <small class="text-danger">{{ errors[0] }}</small>
              <small
                v-if="remarksValidation"
                class="text-danger"
              >
                {{ remarksError }}
              </small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
    <b-modal
      id="terms-condition-modal"
      centered
      hide-footer
      title="Terms and Conditions"
      modal-class="terms-condition-modal"
    >
      <div v-if="selectedEntitlement">
        <!-- eslint-disable vue/no-v-html -->
        <div
          class="terms-condition-content"
          v-html="selectedEntitlement.schemeItemID.termsCondition"
        />
      </div>
    </b-modal>
    <b-modal
      id="modal-edit-selected-option"
      ref="selected-code-modal"
      centered
      hide-footer
      modal-class="edit-selected-option-modal"
      title="Edit Selected Option"
    >
      <div class="inventory-option-list">
        <div
          v-for="(item, index) in inventoryOptions"
          :key="index"
          class="inventory-option-card"
          :class="{ active: isSelected(item) }"
          @click="selectSingleOption(item)"
        >
          <img
            :src="item.item.image ? item.item.image : require('@/assets/images/placeholder/placeholder_image.png')"
            class="option-image"
          >

          <div class="option-content">
            <h5 class="option-title">
              {{ item.item ? item.item.name : '' }}
            </h5>
            <p class="option-sub">
              {{ item.item ? item.item.sku : '-' }}
            </p>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-2">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          @click="$bvModal.hide('modal-edit-selected-option')"
        >
          Cancel
        </b-button>

        <b-button
          variant="success"
          :disabled="selectedOptionTemp.length == 0"
          @click="saveSelectedOption"
        >
          Save Changes
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BButton, BFormInput, BTable, BInputGroup, BInputGroupAppend, BFormCheckbox,
  BBadge, BDropdown, BDropdownItem, BPagination, BForm, BFormGroup, BFormTag, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { required } from '@validations'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import { useUtils as useAclUtils } from '@/libs/acl/custom'

import moment from 'moment'
import store from '@/store'
import ToastificationContentCustom from '../../ToastificationContentCustom.vue'

import useUsedEntitlementList from './useUsedEntitlementList'
import entitlementStoreModule from '../entitlementStoreModule'
import EntitlementDropdownFilters from '../EntitlementDropdownFilters.vue'

export default {
  components: {
    BForm,
    BFormGroup,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormTag,
    BFormTextarea,
    BFormCheckbox,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    vSelect,

    EntitlementDropdownFilters,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      inventoryOptions: [],
      selectedOptionTemp: [],
      schemeOptions: [],
      entitlementID: '',
      name: '',
      validUntil: '',
      validUntilValidation: false,
      validUntilError: 'Valid status is required',
      internalRemarks: '',
      remarksValidation: false,
      remarksError: 'Internal Remarks is required',
      selectedEntitlement: null,
      statusDataOptions: [
        { title: 'Redeemable', code: 'redeemable' },
        { title: 'Redeemed', code: 'redeemed' },
        { title: 'Used', code: 'used' },
        { title: 'Expired', code: 'expired' },
        { title: 'Cancelled', code: 'expired' },
      ],
      showFilterDropdown: process.env.VUE_APP_SHOW_FILTER_DROPDOWN,
      lifeTime: false,
      validityYear: 3,
      validityType: 'Years',
      validityTypes: [
        { title: 'Months', code: 'Months' },
        { title: 'Years', code: 'Years' },
      ],
      validityYears: Array.from({ length: 9 }, (_, i) => ({
        title: (i + 1).toString(),
        code: i + 1,
      })),

      required,
    }
  },
  computed: {
  },
  beforeMount() {
    this.$http.get('reservation/entitlement-schemes/respond-with/name-and-id')
      .then(response => {
        this.schemeOptions = response.data.schemes
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },

  methods: {
    isSelected(item) {
      return this.selectedOptionTemp.some(i => (i.inventoryItemId?._id || i.item._id) === item.item._id)
    },
    selectOption(item) {
      const id = item.item._id

      const index = this.selectedOptionTemp.findIndex(i => (i.inventoryItemId?._id || i.item?._id) === id)

      if (index !== -1) {
        // 🔴 already selected → remove (deselect)
        this.selectedOptionTemp.splice(index, 1)
      } else {
        // 🟢 not selected → add
        this.selectedOptionTemp.push(item)
      }
    },
    selectSingleOption(item) {
      const id = item.item._id
      const alreadySelected = this.selectedOptionTemp.some(i => (i.inventoryItemId?._id || i.item?._id) === id)
      this.selectedOptionTemp = alreadySelected ? [] : [item]
    },
    saveSelectedOption() {
      const payload = {
        selectedOptions: this.selectedOptionTemp.map(item => ({
          inventoryItemId: item.item ? item.item._id : item.inventoryItemId._id,
          quantity: item.quantity || 1,
          store: item.store || null,
        })),
      }

      this.$http.patch(
        `customer/entitlements/${this.entitlementID}/selected-options/update`,
        payload,
      )
        .then(() => {
          this.$emit('emitCountEntitlement')
          this.$bvModal.hide('modal-edit-selected-option')
        })
    },
    openEditSelectedOption(item) {
      this.entitlementID = item._id
      this.$http.get(`customer/entitlements/${item._id}/show`)
        .then(response => {
          this.inventoryOptions = response.data.schemeItem?.inventoryOptions ?? []
          this.selectedOptionTemp = response.data.entitlement.selectedOptions.map(i => ({ ...i }))
          this.$bvModal.show('modal-edit-selected-option')
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    markAsRedeemable(id) {
      this.$swal({
        title: 'Mark as Redeemable?',
        html: 'Are you sure you want to mark this item as redeemable? Once enabled, users may proceed with redemption.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Yes, Mark as Redeemable',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            this.updateStatus(id, 'redeemable')
          }
        })
    },
    markAsRedeemed(id) {
      this.$swal({
        title: 'Mark as Redeemed?',
        html: 'Are you sure you want to redeem this entitlement? This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/success-square.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Go back',
        confirmButtonText: 'Yes, Mark as Redeemed',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
        width: 475,
      })
        .then(async result => {
          if (result.value) {
            this.updateStatus(id, 'redeemed')
          }
        })
    },
    markAsCancelled(id) {
      this.$swal({
        title: 'Mark as Cancelled?',
        html: 'Are you sure you want to cancel this entitlement? This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning-square.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Go back',
        confirmButtonText: 'Yes, Mark as Cancelled',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
        width: 475,
      })
        .then(async result => {
          if (result.value) {
            this.updateStatus(id, 'cancelled')
          }
        })
    },
    undoRedemption(id) {
      this.$swal({
        title: 'Undo Redemption?',
        html: 'Undoing this redemption will also cancel the associated Inventory Request. This action cannot be undone. Do you want to proceed?',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Go back',
        confirmButtonText: 'Undo Redemption',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            this.updateStatus(id, 'redeemable', true)
          }
        })
    },
    resolveStatusTypeLabel(statusType, statusReference) {
      const map = {
        customer_app: 'via Customer App',
        code: 'via Code',
        service_request: `via ${statusReference ?? 'SR'}`,
        manual: 'via Manual',
        system: 'via System',
      }
      return map[statusType] ?? statusType
    },
    openTermsModal(item) {
      this.selectedEntitlement = item
    },
    resolveSchemeName(item) {
      // eslint-disable-next-line eqeqeq
      const index = this.schemeOptions.find(i => i._id == item)
      if (index) {
        return index.name
      }

      return ''
    },
    formatCondition(condition) {
      const { condition: title, startDate, endDate } = condition

      const start = startDate ? moment(startDate, 'DD/MM/YYYY').format('DD/MM/YYYY') : null
      const end = endDate ? moment(endDate, 'DD/MM/YYYY').format('DD/MM/YYYY') : null

      if (start && end) return `${title} ${start} to ${end}`
      if (start) return `${title} from ${start}`
      if (end) return `${title} until ${end}`

      return title
    },
    hideFilter() {
      this.$refs.filter_dropdown_all_entitlement.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_all_entitlement.show(true)
    },
    removeFromStatusFilter(item) {
      const index = this.statusFilter.indexOf(item)
      if (index > -1) {
        this.statusFilter.splice(index, 1)
      }
    },
    removeFromTypeFilter(item) {
      const index = this.typeFilter.indexOf(item)
      if (index > -1) {
        this.typeFilter.splice(index, 1)
      }
    },
    removeFromPaidEntitlementFilter(item) {
      const index = this.paidEntitlementFilter.indexOf(item)
      if (index > -1) {
        this.paidEntitlementFilter.splice(index, 1)
      }
    },
    removeFromSchemeFilter(item) {
      const index = this.schemeFilter.indexOf(item)
      if (index > -1) {
        this.schemeFilter.splice(index, 1)
      }
    },

    clearAllFilters() {
      this.startDateFilter = ''
      this.statusFilter = []
      this.typeFilter = []
      this.paidEntitlementFilter = []
      this.schemeFilter = []
    },

    setEntitlement(item) {
      this.entitlementID = item._id
      this.validUntil = item.validUntil
      this.name = item.name
    },
    setEntitlementRemarks(item) {
      this.entitlementID = item._id
      this.internalRemarks = item.internalRemarks
      this.name = item.name
    },
    submitForm() {
      this.$refs.entitlementValidUntilEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('lifeTime', this.lifeTime)
          formData.append('validityYear', this.validityYear)
          formData.append('validityType', this.validityType)

          this.$http.patch(`customer/entitlements/${this.entitlementID}/validity/update`, formData)
            .then(() => {
              this.refetchData()
              this.$swal({
                title: 'Validity has been updated',
                // html: `The validity for <strong>'${this.name}'</strong> has been updated`,
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/success.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                showConfirmButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
                width: 300,
              })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'validUntil') {
                    this.validUntilError = validationError.msg
                    this.validUntilValidation = true
                  }
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
    sendEmail(entitlement) {
      if (entitlement.customerID && entitlement.customerID.perEmail === null) {
        this.$swal({
          // eslint-disable-next-line global-require
          title: 'No email address found', html: 'The customer has not provided an email address.', imageUrl: require('@/assets/images/icons/warning.png'), imageWidth: 80, imageHeight: 80, imageAlt: 'Custom Icon', showCancelButton: false, confirmButtonText: 'Okay', customClass: { confirmButton: 'btn btn-primary' }, buttonsStyling: false,
        })
        return
      }
      this.$swal({
        // eslint-disable-next-line global-require
        title: 'Re-send Entitlement Email?', html: `An email containing the entitlement details and current status will be sent to ${entitlement.customerID ? entitlement.customerID.perEmail : '-'}.`, imageUrl: require('@/assets/images/icons/mail.png'), reverseButtons: true, showCancelButton: true, cancelButtonText: 'Go back', confirmButtonText: 'Send Email', customClass: { confirmButton: 'btn btn-primary ml-1', cancelButton: 'btn btn-outline-primary' }, buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            this.$http.post(`customer/entitlements/${entitlement._id}/send-email`)
              .then(() => {
                this.$swal({
                  // eslint-disable-next-line global-require
                  title: 'The entitlement status email has been sent', imageUrl: require('@/assets/images/icons/success.png'), imageWidth: 80, imageHeight: 80, imageAlt: 'Custom Icon', showCancelButton: false, showConfirmButton: false, buttonsStyling: false,
                })
              })
          }
        })
    },
    updateStatus(entitlement, status, undo = false) {
      const formData = new FormData()
      formData.append('status', status)
      this.$http.patch(`customer/entitlements/${entitlement._id}/status/update`, formData)
        .then(() => {
          this.$emit('emitCountEntitlement')
          this.refetchData()
          if (status === 'redeemed') {
            const toastMessage = `<span class="text-bold-black">${entitlement.stringID} - ${entitlement.name}</span> has been mark as redeemed successfully.`
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title: 'Mark as Redeemed', text: toastMessage, icon: 'CheckCircleIcon', variant: 'success', hideClose: true,
              },
            })
          } else if (status === 'cancelled') {
            const toastMessage = `<span class="text-bold-black">${entitlement.stringID} - ${entitlement.name}</span> has been mark as cancelled successfully.`
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title: 'Mark as Cancelled', text: toastMessage, icon: 'CheckCircleIcon', variant: 'success', hideClose: true,
              },
            })
          } else if (status === 'redeemable' && !undo) {
            const toastMessage = `<span class="text-bold-black">${entitlement.stringID} - ${entitlement.name}</span> has been mark as redeemable successfully.`
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title: 'Mark as Redeemable', text: toastMessage, icon: 'CheckCircleIcon', variant: 'success', hideClose: true,
              },
            })
          } else if (status === 'redeemable' && undo) {
            this.$swal({
              // eslint-disable-next-line global-require
              title: 'Redemption has been reverted.', imageUrl: require('@/assets/images/icons/success.png'), imageWidth: 80, imageHeight: 80, imageAlt: 'Custom Icon', showCancelButton: false, showConfirmButton: false, buttonsStyling: false,
            })
          }
        })
        .catch(error => {
          if (error.data.status === 'collected') {
            this.$swal({
              // eslint-disable-next-line global-require
              title: 'Unable to Undo Redemption', html: 'This entitlement has already been collected and its redemption can no longer be reversed.', imageUrl: require('@/assets/images/icons/alert-red.png'), imageWidth: 80, imageHeight: 80, imageAlt: 'Custom Icon', showCancelButton: false, confirmButtonText: 'Close', customClass: { confirmButton: 'btn btn-primary' }, buttonsStyling: false,
            })
          } else {
            this.$toast({ component: ToastificationContent, props: { title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE, icon: 'AlertTriangleIcon', variant: 'danger' } })
          }
        })
    },
    submitRemarksForm() {
      this.$refs.entitlementRemarksEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('internalRemarks', this.internalRemarks)

          this.$http.patch(`customer/entitlements/${this.entitlementID}/internal-remarks/update`, formData)
            .then(() => {
              this.refetchData()
              this.$swal({
                title: 'Internal Remarks has been updated',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/success.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                showConfirmButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
                width: 300,
              })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'internalRemarks') {
                    this.remarksError = validationError.msg
                    this.remarksValidation = true
                  }
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
    deleteEntity(id) {
      this.$swal({
        title: 'Delete this Entitlement?',
        html: 'Are you sure you want to delete this article category? Deleting the category will also delete all associated questions. This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/delete-yellow.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, go back',
        confirmButtonText: 'Yes, delete',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            this.toDeletedID = id
            await this.deleteEntitlement()
            this.$emit('emitCountEntitlement')
          }
        })
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const ENTITLEMENT_APP_STORE_MODULE_NAME = 'customers-used-entitlements'

    // Register module
    if (!store.hasModule(ENTITLEMENT_APP_STORE_MODULE_NAME)) store.registerModule(ENTITLEMENT_APP_STORE_MODULE_NAME, entitlementStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ENTITLEMENT_APP_STORE_MODULE_NAME)) store.unregisterModule(ENTITLEMENT_APP_STORE_MODULE_NAME)
    })

    const { canViewThisAction } = useAclUtils()

    const {
      fetchEntitlements,
      tableColumns,
      perPage,
      currentPage,
      totalEntitlements,
      entitlementData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUsedEntitlementsTable,
      refetchData,

      toDeletedID,
      deleteEntitlement,

      // UI
      resolveEntitlementStatusVariant,

      // Extra Filters
      statusFilter,
      typeFilter,
      schemeFilter,
      paidEntitlementFilter,
      startDateFilter,
    } = useUsedEntitlementList()

    return {

      // Sidebar

      fetchEntitlements,
      tableColumns,
      perPage,
      currentPage,
      totalEntitlements,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUsedEntitlementsTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      toDeletedID,
      deleteEntitlement,
      entitlementData,

      // Filter
      avatarText,
      canViewThisAction,

      // UI
      resolveEntitlementStatusVariant,

      // Extra Filters
      statusFilter,
      typeFilter,
      schemeFilter,
      paidEntitlementFilter,
      startDateFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.modal-close-btn,
.close {
  position: relative;
  z-index: 9999;
}
// .inventory-option-card.active {
//   border: 2px solid #28c76f;
//   background-color: rgba(40, 199, 111, 0.1);
// }
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
